@for (item of puffs; let i = $index; track item.id) {
  <app-blog-puff
    [forceContentCssClass]="'p-4'"
    [index]="i"
    [puffData]="item"
    [numberOfPriorityPuffs]="0"
  ></app-blog-puff>
}

